import _ from 'lodash';
import { useEffect } from 'react';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
};

const useRoles = () => {
  const { state: { roles = initialState }, dispatch } = useGlobalContext(),
    { actions: headerActions } = useHeader();

  const { data, mutate } = useFetch({
    url: 'roles/list',
    params: { term: roles.term, offset: roles.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Funções',
      count: _.get(data, 'count', 0),
      loading: _.get(roles, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, roles]);

  const list = (offset = 0, term) => {
    dispatch({ type: 'roles', payload: { offset, term } });
  };

  const pageChange = (offset = 0) => {
    dispatch({ type: 'roles', payload: { offset } });
  };

  const load = async (data = {}) => {
    try {
      dispatch({
        type: 'roles',
        payload: { model: {}, formLoading: true },
      });
      let model = { active: true, value: 0 };

      if (data.id) {
        const response = await api.get('roles/load', { params: { id: data.id } });
        model = response.data;
      }
      dispatch({ type: 'roles', payload: { model, formLoading: false } });
    } catch (error) {
      failure(error, dispatch);
    }
  };

  const createOrUpdate = async (model, actions) => {
    try {
      dispatch({ type: 'roles', payload: { formLoading: true } });

      let editing = !!(model && model.id),
        method = editing ? 'put' : 'post',
        path = editing ? 'update' : 'create';

      await api[method](`roles/${path}`, model);

      mutate(data);

      showMessage('success', `Função ${editing ? 'atualizada' : 'criada'} com sucesso`);

      actions.toogleForm && actions.toogleForm();
    } catch (error) {
      failure(error, dispatch);
    }
  };

  return {
    state: {
      ...roles,
      data: data || {},
      loading: !data,
    },
    actions: {
      pageChange,
      load,
      list,
      createOrUpdate,
    },
  };
};

const failure = (error, dispatch) => {
  dispatch({ type: 'roles', payload: { loading: false, formLoading: false }});
  showMessage('error', error);
};

export default useRoles;
